import { useEffect, useRef } from 'react';
import { CloseIcon } from './icons';

export type StatusToastTone = 'success' | 'warning' | 'error';

export interface StatusToastProps {
  tone: StatusToastTone;
  message: string;
  occurrence?: object;
  onDismiss: () => void;
}

const DISMISS_DELAY: Record<StatusToastTone, number> = {
  success: 3200,
  warning: 5000,
  error: 4800
};

const StatusToast = ({ tone, message, occurrence, onDismiss }: StatusToastProps) => {
  const onDismissRef = useRef(onDismiss);
  onDismissRef.current = onDismiss;

  useEffect(() => {
    const timeoutId = window.setTimeout(() => onDismissRef.current(), DISMISS_DELAY[tone]);
    return () => window.clearTimeout(timeoutId);
  }, [message, occurrence, tone]);

  return (
    <div
      className={`integrations-delete-toast integrations-delete-toast--${tone}`}
      role={tone === 'error' ? 'alert' : 'status'}
      aria-live={tone === 'error' ? 'assertive' : 'polite'}
    >
      <div className="integrations-delete-toast__content">
        <span className="integrations-delete-toast__icon" aria-hidden="true">
          {tone === 'success' ? '\u2713' : '!'}
        </span>
        <span>{message}</span>
      </div>
      <button type="button" className="integrations-delete-toast__close" aria-label="Dismiss notification" onClick={onDismiss}>
        <CloseIcon size={16} />
      </button>
    </div>
  );
};

export default StatusToast;
